export default __webpack_public_path__ + "static/svarga-d8bca5b45101faf676463b606259f3c6.png";